module.exports = __webpack_public_path__ + "static/img/event1.faef7c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/event1.png
// module id = Jv8a
// module chunks = 1